export {
  points,
};

const points = [
  {
    number: 1,
    pos: [47, 71],
  },
  {
    number: 2,
    pos: [56, 56],
  },
  {
    number: 3,
    pos: [64, 43],
  },
  {
    number: 4,
    pos: [63, 26],
  },
  {
    number: 5,
    pos: [61, 16],
  },
  {
    number: 6,
    pos: [53, 7.5],
  },
  {
    number: 7,
    pos: [45, 2],
  },
  {
    number: 8,
    pos: [44, 25],
  },
  {
    number: 9,
    pos: [45, 45],
  },
  {
    number: 10,
    pos: [41.5, 52.5],
  },
  {
    number: 11,
    pos: [34, 70],
  },
  {
    number: 12,
    pos: [45, 93],
  },
];
